import * as actionTypes from './actionTypes'


export function setUDPVars(stateLocation: string, value: unknown): { type: string; payload: { stateLocation: string; value: unknown } } {
    return {
        type: actionTypes.SET_UDP_VARS,
        payload: {
            stateLocation,
            value,
        },
    };
}



// WEBPACK FOOTER //
// ./modules/user-details-post-message/actions/actions.ts